import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=578fbe7c&scoped=true&"
import script from "./AlertError.vue?vue&type=script&lang=ts&"
export * from "./AlertError.vue?vue&type=script&lang=ts&"
import style0 from "./AlertError.vue?vue&type=style&index=0&id=578fbe7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fbe7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
